import Footscanner from '../containers/footscanner';

export default Footscanner;
